// extracted by mini-css-extract-plugin
export default {"SiteDarkGrey":"#5A6268","Footer":"Footer_Footer__FKOdv","active":"Footer_active__eIzob","MadeIn":"Footer_MadeIn__VOUtt","Link":"Footer_Link__0VUlo"};